import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';

import { MenuResponsiveComponent } from '../menuResponsive/menu-responsive.component';

@Component({
  selector: 'app-menu-mantenimiento',
  templateUrl: './menu-mantenimiento.component.html',
  styleUrls: ['./menu-mantenimiento.component.scss'],
})
export class MenuMantenimientoComponent implements OnInit {

  @Input() public menuItemSelected: string = '';
  @Input() public busquedaTxt: string = '';

  //#region Propiedades

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _busquedaTxt: string = null;

  public _appVersion: string;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _router: Router,
              private _popoverCtrl: PopoverController) {
    this._appVersion = GlobalConstants.APP_VERSION;
  }

  //#endregion

  //#region Eventos NG

  public ngOnInit() {}

  public async ionViewDidEnter() {

  }

  //#endregion

  //#region Eventos Botones

  public btnShowMenu() {
    // abre popup para menu
    this._popoverCtrl.create({
      translucent: true,
      component: MenuResponsiveComponent,
      showBackdrop: false,
      cssClass: 'popoverMenu-6Items',
      mode: 'md'
    }).then((popover) => {
      popover.present();
    });
  }

  public btnFavoritos() {

    const navExtras: NavigationExtras = {
      queryParams: {
        f: 1,
      }
    };

    this._router.navigateByUrl('/blank', {skipLocationChange: true}).then(() => {
      this._router.navigate(['/categoriaDetalle'], navExtras);
    });

  }

  //#endregion

  //#region Eventos Controles

  public txtBusquedaBlur() {

    const navExtras: NavigationExtras = {
      queryParams: {
        s: this._busquedaTxt
      }
    };

    this._router.navigateByUrl('/blank', {skipLocationChange: true}).then(() => {
      this._router.navigate(['/categoriaDetalle'], navExtras);
    });

    // this._navCtrl.navigateRoot('/categoriaDetalle', navExtras);
  }

  //#endregion

}
